export default __webpack_public_path__ + "static/media/artistic.bdab0c50.png";